'use client';

import React, { FC, useEffect, useMemo, useState } from 'react';
import { ListProps } from './list.types';
import clsx from 'clsx';
import classes from './list.module.css';
import { GroupedVirtuoso } from 'react-virtuoso';
import { Item } from './components';

const Footer = () => <div className={'pb-lg'} />;

const List: FC<ListProps> = ({ groupBy, sortGroupBy, title, items, className }) => {
  const [isClient, setIsClient] = useState(false);

  
  // Group and sort items
  const groupedItems = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const grouped = items.reduce((acc: Record<string, any[]>, item) => {
     
      const index = groupBy?.(item, acc);
      if(!index) return acc;

      if (!acc[index]) acc[index] = [];
      acc[index].push(item);
        return acc;
    }, {});

    return Object.keys(grouped)
      .sort(sortGroupBy)
      .map((index) => ({
        index,
        items: grouped[index],
      }));
  }, [items, groupBy, sortGroupBy]);

  // Flatten data and group counts for GroupedVirtuoso
  const flattenedItems = useMemo(() => {
    return groupedItems.flatMap((group) => group.items);
  }, [groupedItems]);

  // Count the length of each group
  const groupCounts = useMemo(() => {
    return groupedItems.map((group) => group.items.length);
  }, [groupedItems]);

  useEffect(() => {
    setIsClient(true);
  }, []);


  
  
  return (
    <div className={clsx(classes.list, className)}>

    {isClient ? 
        <GroupedVirtuoso
          className="scrollbar-thin !pb-scroll-lg h-full"
          groupCounts={groupCounts}
          groupContent={(index) => (
              <div className={classes["list-title-container"]}>
                <h2 className={classes["list-title"]}>
                  {title && title(groupedItems[index].items[0])}
                </h2>
              </div>
          )}
          itemContent={(index) => {
            const item = flattenedItems[index];
            return (
              <div className={"px-md"}>
                <Item key={index} {...item}></Item>
              </div>
            );
          }}
          components={{Footer}}
        />
      : <div>Loading...</div>}
   
    </div>
  );
}

export { List };
